import React, { useState, useEffect } from "react";
import Header from "../asset/img/beritaheader.png";
import { Link } from "react-router-dom";
import FloatingMenu from "../components/FloatingMenu";

const ITEMS_PER_PAGE = 9;

const DaftarBerita = () => {
  const [datas, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // To track total pages

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://cms.okoce.net/api/admin/news");
        if (!response.ok) {
          throw new Error("Gagal mengambil data berita");
        }
        const result = await response.json();
        const filteredNews = result.data.filter(
          (news) => news.published_at !== null
        );
  
        filteredNews.sort((a, b) => new Date(a.date) - new Date(b.date));
  
        const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
        const endIndex = startIndex + ITEMS_PER_PAGE;
        const currentData = filteredNews.slice(startIndex, endIndex);
  
        setData(currentData);
        setTotalPages(Math.ceil(filteredNews.length / ITEMS_PER_PAGE));
      } catch (error) {
        setData([]);
      }
    };
  
    fetchData();
  }, [currentPage]);

  // Fungsi untuk ekstraksi gambar dari description
  const extractImagesFromDescription = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const images = doc.querySelectorAll("img");
    const imageUrls = Array.from(images).map((img) => img.src);
    return imageUrls;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <>
      <div className="bg-gray-100">
        <div className="block w-full mt-24 pt-12">
          <img
            className="border-8 border-white mobile:w-full mobile:object-cover mobile:h-[11.3rem] lg:w-11/12 lg:h-[23rem] mx-auto rounded-xl"
            src={Header}
            alt=""
          />
        </div>
        <div className="grid mobile:grid-cols-1 mobile:mt-10 lg:w-11/12 lg:mx-auto lg:grid-cols-3 lg:gap-y-8 lg:gap-x-4 lg:mt-24">
          {datas.map((data, index) => {
            const imageUrls = extractImagesFromDescription(data.description);

            return (
              <div key={index} className="w-full mx-auto p-4">
                <div className="bg-white shadow-md rounded-lg lg:mr-1">
                  <div className="p-5">
                    {imageUrls.length > 0 && (
                      <img
                        className="object-cover w-full mobile:h-36 lg:h-96"
                        src={imageUrls[0]}
                        alt={`From ${data.title}`}
                      />
                    )}
                    <div className="relative group mb-2 mt-6 h-20">
                      <div className="leading-7 text-black font-bold text-xl overflow-hidden line-clamp-2">
                        {data.title}
                      </div>
                      <div className="absolute left-0 bottom-full mb-2 hidden w-full text-xs text-white bg-black p-2 rounded group-hover:block">
                        {data.title}
                      </div>
                    </div>
                    <p className="text-gray-600">Author: {data.author}</p>
                    <div className="flex space-x-4 my-4">
                      <span className="bg-gray-200 text-black text-sm font-semibold mr-2 px-2.5 py-0.5 rounded">
                        Tanggal Publish: {data.date}
                      </span>
                    </div>
                    <Link to={`/daftarberita/${data.id}`}>
                      <div className="mt-8 flex justify-start">
                        <button className="bg-[#1c75ac] w-full text-white font-bold p-2 rounded-lg hover:bg-blue-700 hover:text-white">
                          Read more
                        </button>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-center mt-8 py-8 mx-auto rounded-xl mobile:w-3/4 lg:w-1/2">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="mx-1 py-2 border rounded bg-white text-[#1c75ac] mobile:w-full lg:w-8/12 hover:bg-[#1c75ac] hover:text-white"
          >
            Sebelumnya
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="mx-1 py-2 border rounded bg-white text-[#1c75ac] mobile:w-full lg:w-8/12 hover:bg-[#1c75ac] hover:text-white"
          >
            Selanjutnya
          </button>
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default DaftarBerita;
